module.exports = __webpack_public_path__ + "static/media/arrow-right.b691d9bb.svg";